// src/components/Footer.jsx
import { FOOTER_LINKS } from '../data/content';
import './Footer.css';

export default function Footer() {
  return (
    <footer>
      {/* Main Footer Body */}
      <div className="footer-body">
        <div className="footer-main container">
          {/* Brand Block */}
          <div className="footer-brand">
            <a href="#home" className="footer-logo">
              <span className="dot" />
              AI GAV INDIA PVT LTD
            </a>
            <p>
              Industrial AI and IoT solutions for the next era of manufacturing
              and operations. Built with purpose. Deployed with precision.
            </p>
            <div className="footer-tagline">
              <span className="tagline-dot" />
              Noida, India
            </div>
          </div>

          {/* Link Columns */}
          <div className="footer-links-grid">
            {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
              <div key={heading} className="footer-col">
                <h5>{heading}</h5>
                <ul>
                  {links.map((link) => (
                    <li key={link.label}>
                      <a href={link.href}>{link.label}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom container">
          <p>© 2025 <span className="footer-accent">AI GAV INDIA PVT LTD</span>. All rights reserved.</p>
          <div className="footer-bottom-links">
            {/* <a href="#home">Privacy Policy</a>
            <span className="sep">·</span>
            <a href="#home">Terms of Use</a>
            <span className="sep">·</span> */}
            <span>Made with purpose</span>
          </div>
        </div>
      </div>
    </footer>
  );
}